import { render, staticRenderFns } from "./TheHeaderDropdownAccnt.vue?vue&type=template&id=b2ad5e4e&scoped=true&"
import script from "./TheHeaderDropdownAccnt.vue?vue&type=script&lang=js&"
export * from "./TheHeaderDropdownAccnt.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b2ad5e4e",
  null
  
)

export default component.exports